<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-md-4 align-self-center">
                    <h4 class="page-title">
                        <i class="fas fa-chart-line"></i> Report Vendors
                    </h4>
                </div>
                <div class="col-md-8 align-self-center">
                    <div class="d-flex align-items-right justify-content-end">
                        <router-link :to="{ name: 'BillingReport' }" class="btn btn-info btn-sm mr-2 ctrlbtn" style="margin-bottom: 10px;width: -webkit-fill-available;">
                            <i class="fas fa-arrow-left"></i>
                            Back
                        </router-link>  
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-body" style="min-height: 80vh">                  
                        <div class="row">
                            <!-- start botoneras ajustados a responsive -->
                            <div class="col-md-12">
                                <div class="row">
                                    <div id="divA" class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-3">
                                                <button
                                                    type="button"
                                                    class="btn btn-success mb-2"
                                                    style="width: inherit;min-width: 80px;"
                                                    @click="FilterVendors"
                                                >
                                                    <i class="fas fa-search"></i> Filter
                                                </button>
                                            </div>                               
                                            <div class="col-md-9">
                                                <select
                                                    class="form-control"
                                                    v-model="SelectOne"
                                                    @change="ChangeSelectPrimary"
                                                >
                                                    <option value="1">This Year</option>
                                                    <option value="4">Last Year</option>
                                                    <option value="2">This Month</option>
                                                    <option value="3">Calendar</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="divS" class="col-md-4" v-if="SelectOne == 3">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group row">
                                                    <label class="col-sm-3 col-form-label"><b>From:</b></label>
                                                    <div class="col-sm-9">
                                                        <datetime
                                                            type="date"
                                                            v-model="startdate"
                                                            format="MMM dd, yyyy"
                                                            input-class="form-control"
                                                            value-zone="America/New_York"
                                                        ></datetime>                                                                   
                                                    </div>
                                                </div>                               
                                            </div>
                                            <div class="col-md-6">   
                                                <div class="form-group row">
                                                    <label class="col-sm-3 col-form-label"><b>To:</b></label>
                                                    <div class="col-sm-9">
                                                        <datetime
                                                            type="date"
                                                            v-model="enddate"
                                                            format="MMM dd, yyyy"
                                                            input-class="form-control"
                                                            value-zone="America/New_York"
                                                        ></datetime>           
                                                    </div>                                             
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="divB" class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <model-select
                                                        style="width: 200px"
                                                        :options="ListVendors"
                                                        v-model="vendor_id"
                                                        @input="handleOnInput"
                                                        placeholder="Choose a Vendors"
                                                    >
                                                    </model-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="divC" v-if="SelectOne != 3" class="col-md-6">
                                        <div style="display: flex; justify-content: flex-end">
                                            <span class="cdropdown" style="margin-bottom: 10px;">
                                                <button class="btn btn-transaction">
                                                    Export As
                                                </button>
                                                <label>
                                                    <input type="checkbox" />
                                                    <ul class="text-left">
                                                        <li @click="generarFile('pdf')">
                                                            <button><strong>PDF</strong></button>
                                                        </li>
                                                        <li @click="generarFile('csv')">
                                                            <button>
                                                                CSV (Comma Separated Value)
                                                            </button>
                                                        </li>
                                                        <!-- <li @click="generarFile('xls')"><button>XLS (Microsoft Excel 1997 - 2004 Compatible)</button></li> -->
                                                        <li @click="generarFile('xlsx')">
                                                            <button>
                                                                XLSX (Microsoft Excel)
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </label>
                                            </span>
                                        </div>
                                    </div>   
                                    <div id="divC" v-else class="col-md-2">
                                        <div style="display: flex; justify-content: flex-end">
                                            <span class="cdropdown" style="margin-bottom: 10px;">
                                                <button class="btn btn-transaction">
                                                    Export As
                                                </button>
                                                <label>
                                                    <input type="checkbox" />
                                                    <ul class="text-left">
                                                        <li @click="generarFile('pdf')">
                                                            <button><strong>PDF</strong></button>
                                                        </li>
                                                        <li @click="generarFile('csv')">
                                                            <button>
                                                                CSV (Comma Separated Value)
                                                            </button>
                                                        </li>
                                                        <!-- <li @click="generarFile('xls')"><button>XLS (Microsoft Excel 1997 - 2004 Compatible)</button></li> -->
                                                        <li @click="generarFile('xlsx')">
                                                            <button>
                                                                XLSX (Microsoft Excel)
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </label>
                                            </span>
                                        </div>
                                    </div>                                                                        
                                </div>
                            </div>
                            <!-- end botoneras ajustados a responsive -->                          
                            <div class="col-md-12">
                                <Loader class="bgloading" v-if="isLoading"></Loader>
                                <div class="contenedor-table" id="expenses" v-else>
                                    <table
                                        class="table table-striped table-bordered table-hover"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Vendor Name</th>
                                                <th>Date</th>
                                                <th>Exp #</th>
                                                <th>Memo</th>
                                                <th style="text-align: right">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td
                                                    style="
                                                        font-weight: bold;
                                                        text-align: right;
                                                    "
                                                >
                                                    ${{ total | formatMoney }}
                                                </td>
                                            </tr>
                                            <tr v-if="noresult">
                                                <td colspan="5">
                                                    <div
                                                        style="
                                                            text-align: center;
                                                            color: red;
                                                        "
                                                    >
                                                        No result
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr
                                                v-for="(i, index) in VendorallList"
                                                :key="index"
                                                v-else
                                            >
                                                <td>{{ i.vendor_name }}</td>
                                                <td>{{ i.fecha }}</td>
                                                <td>{{ i.numdoc }}</td>
                                                <td>{{ i.memo_ex }}</td>
                                                <td style="text-align: right">
                                                    ${{ i.totalAmount | formatMoney }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <td></td>
                                                <th
                                                    style="
                                                        font-weight: bold;
                                                        text-align: right;
                                                    "
                                                >
                                                    ${{ total | formatMoney }}
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/core/components/shared/Loader";
import { ModelSelect } from "vue-search-select";
export default {
    components: {
        Loader,
        ModelSelect,
    },
    name: "VendorsReport",
    data() {
        return {
            isLoading: false,
            dateFrom: new Date().toISOString(),
            dateTo: new Date().toISOString(),
            thisYear: null,
            thisMonth: null,
            SelectOne: 1,
            vendor_id: "",
            ListVendors: [],
            VendorallList: [],
            total: 0,
            startdate: new Date(
                (new Date().toISOString() + "").slice(0, 10) + "T06:00:00.000Z"
            ).toISOString(),
            enddate: new Date(
                (new Date().toISOString() + "").slice(0, 10) + "T06:00:00.000Z"
            ).toISOString(),
            noresult: false,
        };
    },
    watch: {
        startdate: function () {
            this.formatearFecha();
            this.dateFrom = this.startdate;
        },
        enddate: function () {
            this.formatearFecha();
            this.dateTo = this.enddate;
        },
    },
    created() {
        this.getVendorsList();
        this.FilterVendors();
    },
    mounted() {
        this.setTimeoutResponsive()
    },
    methods: {
        modoResponsive() {
            let divA = document.getElementById("divA");
            let divB = document.getElementById("divB");
            let divC = document.getElementById("divC");
            let divS = document.getElementById("divS");
            if (screen.width === 1024 && screen.height === 1366) {
                if (divA !== null) {
                    divA.classList.remove("col-md-3");	
                    divA.classList.add("col-md-12");
                }
                if (divB !== null) {
                    divB.classList.remove("col-md-3");	
                    divB.classList.add("col-md-6");
                }
                if (divC !== null) {
                    divC.classList.remove("col-md-3");	
                    divC.classList.add("col-md-6"); 
                }
                if (divS !== null) {
                    divS.classList.remove("col-md-4");	
                    divS.classList.add("col-md-12"); 
                }                                               	
            }
            if (screen.width === 768 && screen.height === 1024) {
                if (divA !== null) {
                    divA.classList.remove("col-md-3");	
                    divA.classList.add("col-md-12");
                }
                if (divB !== null) {
                    divB.classList.remove("col-md-3");	
                    divB.classList.add("col-md-6");
                }
                if (divC !== null) {
                    divC.classList.remove("col-md-3");	
                    divC.classList.add("col-md-6"); 
                }
                if (divS !== null) {
                    divS.classList.remove("col-md-4");	
                    divS.classList.add("col-md-12"); 
                }  
            } 
            if (screen.width === 1024 && screen.height === 600) {
                if (divA !== null) {
                    divA.classList.remove("col-md-3");	
                    divA.classList.add("col-md-12");
                }
                if (divB !== null) {
                    divB.classList.remove("col-md-3");	
                    divB.classList.add("col-md-6");
                }
                if (divC !== null) {
                    divC.classList.remove("col-md-3");	
                    divC.classList.add("col-md-6"); 
                }
                if (divS !== null) {
                    divS.classList.remove("col-md-4");	
                    divS.classList.add("col-md-12"); 
                }                                              	
            }
            if (screen.width === 1280 && screen.height === 800) {
                if (divA !== null) {
                    divA.classList.remove("col-md-3");	
                    divA.classList.add("col-md-12");
                }
                if (divB !== null) {
                    divB.classList.remove("col-md-3");	
                    divB.classList.add("col-md-6");
                }
                if (divC !== null) {
                    divC.classList.remove("col-md-3");	
                    divC.classList.add("col-md-6"); 
                }
                if (divS !== null) {
                    divS.classList.remove("col-md-4");	
                    divS.classList.add("col-md-12"); 
                }                                               	
            }
        },
        ChangeSelectPrimary() {
            this.setTimeoutResponsive()
        },
        setTimeoutResponsive() {
			let t = this
			setTimeout(function () {
				t.modoResponsive()
			}, 1000); 
        },         
        formatearFecha() {
            this.startdate = new Date(
                (new Date(this.startdate).toISOString() + "").slice(0, 10) +
                    "T06:00:00.000Z"
            ).toISOString();
            if (this.enddate != "") {
                this.enddate = new Date(
                    (new Date(this.enddate).toISOString() + "").slice(0, 10) +
                        "T06:00:00.000Z"
                ).toISOString();
            }
        },
        handleOnInput($event) {
            this.vendor_id = $event;
            this.FilterVendors();
        },
        getVendorsList() {
            this.isLoading = true;
            window.billing
                .get("vendors/" + window.localuserdata)
                .then((response) => {
                    console.log("vendors list");
                    console.log(response.data.result);
                    if (response.data.result.length > 0) {
                        let VendorsList = [{ value: "", text: "All Vendors" }];
                        for (let item in response.data.result) {
                            let t = response.data.result[item].company_name;
                            VendorsList.push({
                                value: response.data.result[item].id,
                                text: t,
                            });
                        }
                        console.log("list vendos");
                        console.log(VendorsList);
                        this.ListVendors = VendorsList;
                        this.isLoading = false;
                    }
                })
                .catch((error) => console.log(error));
        },
        /* generarFiles(type){
	    	this.$swal({
            	title: "Export",
            	text: "Export Report as "+type+" (Microsoft Excel)",
            	icon: "info",
            	allowOutsideClick: false,
            	showCancelButton: true,
            	confirmButtonColor: "#3085d6",
            	cancelButtonText: 'Cancel',
            	confirmButtonText: "Export",
            	showLoaderOnConfirm: true,
            	preConfirm: () => {
	            	window.billing.post('report/export/vendors',{
					user_id: window.localuserdata,
					selecttype: this.SelectOne,
					vendor_id: this.vendor_id,
					dateFrom: this.dateFrom,
					dateTo: this.dateTo,
					filetype : type,
	                })
	                .then(response => {
	                    console.log(response.data);
	                    this.isLoading = false;
	                    window.open(window.urlbase+'files/'+response.data.result);                    
	                })
	                .catch(error => {
	                  this.$swal.showValidationMessage(
	                    `Request failed: ${error}`
	                  )
	                })
            	},
            	allowOutsideClick: () => !this.$swal.isLoading()
            })
            .then((result) => {
            	if (result.value) {
            		this.$swal.fire({
            			allowOutsideClick: false,
            			text: `Successfully downloaded`,
            			confirmButtonText: "Close",
            			showLoaderOnConfirm: true,
            			preConfirm: () => {
            				this.DeleteFile();
            			},
            		});
            	}
            });
        }, */
        DeleteFile() {
            let name = "vendors_report";
            window.billing
                .get("report/vendors/deletefiles/" + window.localuserdata + "/" + name)
                .then((response) => {
                    console.log(response.data.result);
                })
                .catch((error) => console.log(error));
        },
        generarFile(type) {
            let user_id = window.localuserdata;
            let selecttype = this.SelectOne;
            let vendor_id = this.vendor_id == "" ? 0 : this.vendor_id;
            let dateFrom = this.dateFrom;
            let dateTo = this.dateTo;
            let uri =
                "report/vendors/pdf/" +
                user_id +
                "/" +
                selecttype +
                "/" +
                vendor_id +
                "/" +
                dateFrom +
                "/" +
                dateTo +
                "/" +
                type;
            window.open(window.urlbase + "api/v2/" + uri, "_blank");
        },
        FilterVendors() {
            this.isLoading = true;
            window.billing
                .post("vendors/report", {
                    user_id: window.localuserdata,
                    selecttype: this.SelectOne,
                    vendor_id: this.vendor_id,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo,
                })
                .then((response) => {
                    console.log("result reports Vendors");
                    console.log(response.data.result);
                    this.isLoading = false;
                    let e = response.data.result;
                    this.VendorallList = e;
                    console.log("list", e);
                    this.total = 0;
                    if (Object.keys(e).length > 0) {
                        this.noresult = false;
                        for (let i in e) {
                            this.total += parseFloat(e[i].totalAmount);
                        }
                    } else {
                        this.noresult = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="css" scoped>
.contenedor-table table thead tr th {
    font-weight: bold;
}
@media (max-width: 1100px) {
    .contenedor-table {
        max-width: 924px;
        overflow-x: scroll;
    }
}
@media (min-width: 1280px) {
    .ctrlbtn {
        width:100px !important;
    }
}
</style>
